import classnames from "classnames";
import { tier0s } from "constant/shared-constants";
import { useTranslation } from "next-i18next";
import CategoryViewItem from "../categories-viewer/CategoryViewItem";
import styles from "./allProducts.module.scss";
import { AllDropDown } from "./shared-styled";

function AllProducts() {
  const { t } = useTranslation("category-map");
  return (
    <AllDropDown className="container-fluid">

      <div className="row">
        {tier0s.map((category: any, index: any) => (
          <div key={index} className="col-sm-3">

            <div className="container-item">

              <CategoryViewItem
                categoryObj={{
                  tier0: category.name,
                }}
              >

                <>

                  <div className={styles.container_item_image}>

                    <img
                      alt={category.name}
                      className={classnames(
                        `media-object ${styles[category.icon]} ${styles.department_icon} center-block`,
                      )}
                      src={`${process.env.NEXT_PUBLIC_ROOT_URL}/images/sprites/transparent_16051637.png`}
                    />
                  </div>

                  <h5>{t(category.name)}</h5>
                </>
              </CategoryViewItem>
            </div>
          </div>
        ))}
      </div>
    </AllDropDown>
  );
}

export default AllProducts;
